import axios from 'axios';
import {getObjectInLS} from './util/localstorage';
import configData from "@/config";

const request = axios.create({
    baseURL: configData.apiBaseUrl
});

request.interceptors.request.use(function (config) {
    const user = getObjectInLS('user');
    if (user) {
        config.headers.Authorization = 'bearer ' + user.token;
    }

    return config;
});

const withHeader = data => {
    return {
        header: {
            txId: '',
            txSn: ''
        },
        body: {
            data
        }
    };
};

const buildFormData = payload => {
    const formData = new FormData();
    for (const key in payload) {
      formData.append(key, payload[key]);
    }
    // for (const key in payload.files) {
    //   formData.append('image', payload.files[key])
    // }
    return formData;
};

export const extractData = res => {
    const {
        data: {
            body: {
                data
            }
        }
    } = res;

    return data;
};

export const extractHeader = res => {
    const {
        data: {
            header
        }
    } = res;

    return header;
};

// Auth api
export const apiLogin = data => request.post('/loginConsole', withHeader(data));
export const apiLogout = data => request.post('/logout', withHeader(data));
export const refresh = data => request.post('/refresh', withHeader(data));

// Main api
export const getCurrentSituation = data => request.get('/console/home/info');
export const getWaitForApprovalUser = data => request.post('/console/user/wait/approval', withHeader(data));
export const confirmUserStatus = data => request.post('/confirmUserStatus', withHeader(data));

// Admin api
// export const apiRegisterAdmin = data => request.post('/registerByAdmin', withHeader(data));
export const addUserByAdmin = data => request.post('/console/user', withHeader(data));
export const apiUpdateUser = data => request.post(`/console/user/${ data.id }`, withHeader(data));
export const getAllAdmin = data => request.get('/console/admin/all', withHeader(data));
export const resetPasswordByAdmin = data => request.post('/resetPasswordByAdmin', withHeader(data));
export const updateUserPoint = data => request.post('/console/user/point', withHeader(data));

// user api
export const apiGetUser = data => request.get(`/console/user/${data.id}`);
export const apiDeleteUser = data => request.delete('/console/user', { data: withHeader(data) });
export const getAllUser = data => request.get('/console/user/all');
export const searchUser = data => request.post('console/user/search', withHeader(data));
export const getUserNameByIds = params => request.get('console/user/name', { params : params }); // find not use @20221220
export const updateUserMedal = data => request.post('/console/user/medal', withHeader(data));
export const bulkUpdateUserMedal = data => request.post('/console/user/medal/bulk', withHeader(data));
export const bulkUpdateUserProgramInfo = data => request.post('/console/user/program-info/bulk', withHeader(data));
export const updateUserProgramInfo = data => request.post('/console/user/program-info', withHeader(data));

// song api
export const getSong = params => request.get(`/console/song/${params.id}`);
export const deleteSong = params => request.delete(`/console/song/${params.id}`);
export const getSongsById = data => request.post('/console/song/list', withHeader(data));
export const getAllSong = data => request.get('/console/song/all', withHeader(data));
export const advancedSearch = data => request.post('/app/song/search', withHeader(data));
export const nlSearchSong = data => request.post('/app/song/nl-search', withHeader(data));
export const searchFeedback = data => request.post('/app/search/feedback', withHeader(data));
export const searchLogList = params => request.get('/console/search-log', { params });

export const newMultiSong = data => request.post('/console/song/new', withHeader(data));
export const updateSong = data => request.post('/console/song', withHeader(data));
export const bulkUpdateSong = data => request.post('/console/song/bulk', withHeader(data));
export const getSongProperty = () => request.get('/console/song/property');

// upload api
export const getPresignedUrl = data => request.post(`/console/upload/presigned`, withHeader(data));
export const getPresignedUrlForChat = data => request.post(`/console/chat/upload/presigned`, withHeader(data));

// album api
export const getAlbum = params => request.get(`console/album/${params.id}`);
export const deleteAlbum = params => request.delete(`console/album/${params.id}`);
export const getAllAlbum = params => request.get('console/album/all', { params: params });
export const getAlbumNames = () => request.get('console/album/all/name');
export const getSongsByAlbumAdmin = data => request.get(`/console/song/album/${data.id}`);
export const createAlbumAndSong = data => request.post('/console/album/new', withHeader(data));
export const updateAlbumAndSong = data => request.post('/console/album/edit', withHeader(data));
export const bulkAlbumAlbumCarousel = data => request.post('/console/carousel', withHeader(data));
export const getCarouselInfo = () => request.get('/console/carousel');

// point
export const searchChangeUserPointLog = data => request.post('/console/user/point/log/search', withHeader(data));

// category
export const getAllCategory = data => request.get('/song/category/all', withHeader(data));

// seCategory
export const getAllSeCategory = data => request.get('/song/seCategory/all', withHeader(data));

// attribute
export const getSongAttributes = () => request.get('song/attribute/all');

// purchase log
export const getSongPurchaseAggregate = params => request.get('console/purchases/aggregate', { params : params });
export const getSongDownloadAggregate = params => request.get('console/download/aggregate', { params : params });

// news api
export const getNews = () => request.get('/console/news');
export const updateNews = data => request.post('/console/news', withHeader(data));

// category
export const getAllPrefecture = () => request.get('/prefecture/all');
export const getUserPurposeTypes = () => request.get('/user/purpose/type');

// user song tags
export const getUserTagCloud = () => request.get('/console/song/tag/cloud/user');
export const getNgWords = () => request.get('/console/song/tag/ng');
export const createNgWords = data => request.post('console/song/tag/ng', withHeader(data));
export const deleteNgWords = data => request.delete('console/song/tag/ng', { data: withHeader(data) });
export const getTagDetail = params => request.get('console/song/tag/detail', { params : params });
export const updateTagStatus = data => request.post(`console/song/tag/${ data.id }/status`, withHeader(data));
export const getTagMasterList = params => request.get('console/song/tag/master', { params : params });
export const getTagCategoryList = () => request.get('console/song/tag/category');
export const createTagCategory = data => request.post('console/song/tag/category/new', withHeader(data));
export const editTagCategory = data => request.post('console/song/tag/category/edit', withHeader(data));
export const deleteTagCategory = id => request.delete(`console/song/tag/category/${id}`);
export const createTagMaster = data => request.post('console/song/tag/master/new', withHeader(data));
export const editTagMaster = data => request.post('console/song/tag/master/edit', withHeader(data));
export const deleteTagMaster = id => request.delete(`console/song/tag/master/${id}`);
export const getTagMasterCandidates = params => request.get('console/song/tag/master/candidates', { params : params });
export const postTagSuggest = data => request.post('console/song/tag-suggest', withHeader(data));
export const getTagSuggest = params => request.get('console/song/tag-suggest', { params : params });

// mail log
export const getMailHistory = params => request.get('console/email', { params : params });
// export const createMail = data => request.post('console/email', withHeader(data));
export const createMail = payload => request.post(
    'console/email',
    buildFormData(payload),
    {
        headers: {
            "Content-type": "multipart/form-data",
        },
    }
);

// playlist
export const searchPlaylist = data => request.post(`console/playlist/search`, withHeader(data));
export const getPlaylistDetail = data => request.get(`console/playlist/${ data.id }`);
export const getAllPlaylist = () => request.get(`console/playlist/all`);
export const getPlaylistNames = () => request.get('console/playlist/all/name');
export const createPlaylist = data => request.post(`console/playlist`, withHeader(data));
export const updatePlaylist = data => request.post(`console/playlist/${ data.id }`, withHeader(data));
export const deletePlaylist = data => request.delete(`console/playlist/${ data.id }`);
export const updatePlaylistSort = data => request.post(`console/playlist/sort`, withHeader(data));
export const getDailyPlaylist = () => request.get(`console/playlist/daily`);
export const getRandomSongsForDaily = () => request.get(`console/playlist/daily/random-songs`);

// creator
export const getAllCreator = data => request.get(`console/creator/all`, withHeader(data));
export const newCreator = data => request.post(`console/creator`, withHeader(data));
export const showCreator = data => request.get(`console/creator/${ data.id }`, withHeader(data));
export const searchCreator = data => request.post(`console/creator/search`, withHeader(data));
export const updateCreator = data => request.post(`console/creator/${ data.id }`, withHeader(data));
export const updateCreatorStatus = data => request.post(`console/creator/status/${ data.id }`, withHeader(data));
export const deleteCreator = data => request.delete(`console/creator/${ data.id }`, withHeader(data));

// inquiry
export const getAllInquiry = data => request.get(`console/inquiry/all`, withHeader(data));
export const getInquiryDetail = data => request.get(`console/inquiry/${ data.id }`);
export const getInquiryUserName = data => request.get(`console/inquiry/user/${ data.id }`);
export const sendInquiryMessageToUser = data => request.post(`console/inquiry/${data.id}`, withHeader(data));
export const adminMarkAsRead = data => request.post(`console/inquiry/read/${data.id}`, withHeader(data));
export const getAdminTotalUnreadCount = () => request.get('console/inquiry/unread-count');

// OpenChat
// チャット取得
export const getConsoleOpenChatSummary = (data = {}) => {
    const payload = withHeader(data);
    return request.get(`console/openchat/summary`, {
        ...payload,
        params: data,
    });
};
// チャット送信
export const sendConsoleOpenChatMessage = data => request.post(`console/openchat`, withHeader(data));
// チャット更新
export const updateConsoleOpenChatMessage = data => request.put(`console/openchat/${data.messageId}`, withHeader(data));
// チャット削除（自身）
export const deleteConsoleOpenChatMessage = data => request.delete(`console/openchat/${data.messageId}`, withHeader(data));
// チャット既読数算出
export const getConsoleOpenChatUnreadCount = data => request.get(`console/openchat/unread-count`, withHeader(data));
// 一般ユーザーのチャットを非表示
export const adminDeleteConsoleOpenChatMessage = data => request.post(`console/openchat/${data.messageId}/moderate-delete`, withHeader(data));
// チャット既読
export const markConsoleOpenChatMessagesAsRead = data => request.post('console/openchat/reads', withHeader(data));
